import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {useLoaderData} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import Banner from '../uikit/Banner';
import {ICompetitionCategory} from './CultureInterface';
import {appConfig} from '@config';


export default function CultureCompetitions() {
	const categories = useLoaderData() as ICompetitionCategory[];
	const {t} = useTranslation();
	return (
		<>
			<HeaderWithIcons title={t('culture_competition')}/>
			<div className="flex flex-col space-y-2 px-4">
				{
					categories ?
						categories.map(category => <Banner
							key={category.id}
							title={category.name}
							image={category.image}
							url={`/competition-old/${category.id}`}
							state={category}/>)
						:
						''
				}
			</div>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function categoriesLoader(data: loader) {
	const res = await axios({
		url: `${appConfig.competition.url}categories`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
